import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=62288716&scoped=true"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62288716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62288716')) {
      api.createRecord('62288716', component.options)
    } else {
      api.reload('62288716', component.options)
    }
    module.hot.accept("./Contracts.vue?vue&type=template&id=62288716&scoped=true", function () {
      api.rerender('62288716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/Contracts.vue"
export default component.exports